import { useEffect, useState, useCallback } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { getAllProjectRooms, RoomLocation } from '../api/dataCenter';

export const useProjectRooms = (projectId: string) => {
  const [rooms, setRooms] = useState<RoomLocation[]>([]);
  const [loading, setLoading] = useState(false);
  const { keycloak: { token } } = useKeycloak();

  const loadRooms = useCallback(async () => {
    if (!projectId || !token) {
      return;
    }

    setLoading(true);
    
    try {
      const roomsData = await getAllProjectRooms(token, projectId);
      setRooms(roomsData || []);
    } catch (err: any) {
      console.error('useProjectRooms: Failed to load rooms:', err);
      setRooms([]);
    } finally {
      setLoading(false);
    }
  }, [projectId, token]);

  useEffect(() => {
    loadRooms();
  }, [loadRooms]);

  return { rooms, loading, refetch: loadRooms };
}; 